/** Shared layout tokens for compose / reply mail dialogs */
export const emailDialogContentSx = {
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
};

export const attachmentDropLabelSx = {
  width: '100%',
  boxSizing: 'border-box',
  border: '2px dashed #ccc',
  borderRadius: 1,
  p: 2,
  textAlign: 'center',
  cursor: 'pointer',
  display: 'block'
};

export const attachmentChipSx = {
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #ccc',
  borderRadius: 1,
  p: 1
};
